/* Shopify owns prices, availability, line keys and checkout. Local previews keep their separate demo cart. */
(() => {
  if (!document.body.dataset.shopifyCart) return;
  const root = document.body.dataset.root || '/';
  const url = path => root + path;
  const request = async (path, body) => {
    const response = await fetch(url(path), {credentials:'same-origin', cache:'no-store', ...(body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Je winkelmand kon niet worden bijgewerkt. Probeer het opnieuw.');
    return result;
  };
  let catalog, state, chain = Promise.resolve();
  const productCache = new Map();
  const loadProduct = async handle => {
    if (!productCache.has(handle)) productCache.set(handle, request('products/'+handle+'.js'));
    return productCache.get(handle);
  };
  const loadCatalog = async data => {
    catalog = data;
    await Promise.all(data.products.map(async product => {
      const source = await loadProduct(product.shopify_purchase_handle || product.handle);
      for (const variant of product.variants) {
        const actual = source.variants.find(x=>String(x.id)===String(variant.id));
        variant.available = !!actual?.available;
        if (actual) {variant.price=actual.price; if(!variant.compare_locked) variant.compare=actual.compare_at_price || variant.compare; variant.selling_plans=actual.selling_plan_allocations || [];}
      }
      for (const offer of product.preview_offers) {
        const actual = source.variants.find(x=>String(x.id)===String(offer.variant_id));
        offer.available=!!actual?.available;
        if (actual && !offer.price_locked) {offer.price=actual.price*offer.variant_quantity; if(!offer.compare_locked) offer.compare=(actual.compare_at_price || offer.compare/offer.variant_quantity)*offer.variant_quantity;}
      }
      const eligiblePlan = source.selling_plan_groups?.flatMap(group=>group.selling_plans).find(plan=>/28/.test(plan.name) && plan.price_adjustments?.some(p=>p.value_type==='percentage' && p.value===25));
      product.selling_plan_id=eligiblePlan?.id || null;
      if(eligiblePlan)for(const offer of product.preview_offers){const actual=source.variants.find(v=>String(v.id)===String(offer.variant_id));const allocation=actual?.selling_plan_allocations?.find(a=>String(a.selling_plan_id)===String(eligiblePlan.id));if(allocation)offer.refill_price=allocation.price*offer.variant_quantity;}
    }));
    // Never offer a recurring purchase without a real selling plan.
    if (!data.products.find(p=>p.handle===data.hero_handle)?.selling_plan_id) document.querySelectorAll('[data-refill-toggle]').forEach(input=>{input.checked=false; const panel=input.closest('.nn-refill'); if(panel) panel.hidden=true; else input.closest('label')?.setAttribute('hidden','');});
    return data;
  };
  const offerFor = item => {
    const key=item.properties?._noleeOffer;
    return catalog.products.flatMap(p=>p.preview_offers.map(o=>({product:p,offer:o}))).find(x=>key ? x.offer.offer_key===key && String(x.offer.variant_id)===String(item.variant_id) : String(x.offer.variant_id)===String(item.variant_id) && x.offer.variant_quantity===1);
  };
  // Dedicated free gift variants can also exist in older carts without our line property.
  const giftKindFor = item => {
    if(String(item.variant_id)===String(catalog.gift.id)) return 'soap';
    if(String(item.variant_id)===String(catalog.mystery_gift.production_variant_id)) return 'mystery';
    return ['soap','mystery'].includes(item.properties?._noleeGift) ? item.properties._noleeGift : null;
  };
  const hasPaidItems = (cart=state) => !!cart?.items?.some(item=>item.quantity>0 && !giftKindFor(item));
  // v34 bundelsamensteller: regels met _nnBundel tellen samen. Vanaf 3 stuks hoort het verrassingscadeau erbij, net als bij 2+1.
  // 15 okt: ook losse producten (1 flesje/1 zeepje) van de productpagina tellen mee, en vanaf 5 stuks komt de zeep erbij, net als bij 3+2.
  const BUNDLE_MIN = 3, BUNDLE_SOAP_MIN = 5;
  const isSingle = item => {const match=offerFor(item); return !!match && /:pack-1$/.test(match.offer.offer_key||'') && !/^bundel-/.test(match.product.handle||'');};
  const bundleUnits = cart => (cart?.items||[]).filter(item=>item.quantity>0 && !giftKindFor(item) && (item.properties?._nnBundel || isSingle(item))).reduce((sum,item)=>sum+item.quantity,0);
  const syncGifts = async () => {
    let current=await request('cart.js');
    const policy=[{id:catalog.mystery_gift.production_variant_id,flag:'mystery_gift_eligible',kind:'mystery'},{id:catalog.gift.id,flag:'gift_eligible',kind:'soap'}];
    for (const gift of policy) {
      if (!gift.id) continue;
      const choices=current.items.filter(item=>item.quantity>0 && !giftKindFor(item)).map(offerFor).filter(Boolean);
      const eligible=choices.some(x=>x.offer[gift.flag]) || bundleUnits(current)>=(gift.kind==='mystery' ? BUNDLE_MIN : BUNDLE_SOAP_MIN);
      const items=current.items.filter(item=>giftKindFor(item)===gift.kind);
      const keep=eligible ? items.find(item=>String(item.variant_id)===String(gift.id)) : null;
      // Remove all stale/duplicate gift lines, including untagged legacy free variants.
      // The paid Soap variants have different IDs and remain ordinary purchased products.
      for (const item of items) if(item!==keep) {
        await request('cart/change.js',{id:item.key,quantity:0});
        current=await request('cart.js');
      }
      if(keep && keep.quantity!==1) {
        await request('cart/change.js',{id:keep.key,quantity:1});
        current=await request('cart.js');
      } else if(eligible && !keep) {
        await request('cart/add.js',{items:[{id:Number(gift.id),quantity:1,properties:{_noleeGift:gift.kind}}]});
        current=await request('cart.js');
      }
    }
    current=await request('cart.js');
    state=current;
    return state;
  };
  const run = operation => {
    const result=chain.then(operation); chain=result.catch(()=>{}); return result;
  };
  window.NoleeShopify={
    loadCatalog, get state(){return state;}, offerFor, giftKindFor, hasPaidItems,
    read:()=>run(syncGifts),
    add:(choice)=>run(async()=>{
      if(choice.refill && !choice.product.selling_plan_id) throw new Error('Automatisch aanvullen is nog niet beschikbaar. Kies een eenmalige aankoop.');
      await request('cart/add.js',{items:[{id:Number(choice.offer.variant_id),quantity:choice.offer.variant_quantity,properties:{_noleeOffer:choice.offer.offer_key,'Bundel':choice.offer.label},...(choice.refill?{selling_plan:choice.product.selling_plan_id}:{})}]});
      return syncGifts();
    }),
    // v34 bundelsamensteller: meerdere regels in één keer (Cart AJAX API), daarna dezelfde cadeaucontrole.
    addItems:(items)=>run(async()=>{await request('cart/add.js',{items});return syncGifts();}),
    change:(key,quantity)=>run(async()=>{await request('cart/change.js',{id:key,quantity});return syncGifts();}),
    update:(updates)=>run(async()=>{await request('cart/update.js',{updates});return syncGifts();}),
    settled:()=>chain,
    checkout:()=>url('checkout')+'?locale=nl'
  };
})();
